/*global window  */

const url = window.location.origin + "/login";
const redirectUri = url + "/login.html";
const postLogoutRedirectUri = url + "/logout.html";
export const settings = (authority: string, clientId: string) => {
  return {
    // authority: "https://trial-4013249-admin.okta.com/oauth2/default",
    // authority: "https://idp-testinfra.platformteam.saastagetik.com",
    authority: authority,
    // client_id: "0oa571aro2uBW1mHq697",
    // client_id: "co2-idp-testinfra",
    client_id: clientId,
    redirect_uri: redirectUri,
    post_logout_redirect_uri: postLogoutRedirectUri,
    response_type: "code",
    //response_mode: 'fragment',
    filterProtocolClaims: true,
    scope: `openid${authority?.includes("okta.com") ? " offline_access" : ""}`, //TEMP waiting idp support for refresh token
  };
};
